import {
  AttachmentUrls,
  RasterLayerMetadata,
} from "@/components/graphql/customTypes";

export type NodeMetadata = RasterLayerMetadata & {
  parentId: string | null;
  depth: number;
  attachmentUrl?: string;
};

export type RasterLayerTreeItem = {
  id: string;
  label: string;
  // eslint-disable-next-line no-restricted-syntax
  children?: RasterLayerTreeItem[];
  metadata: NodeMetadata;
};

export type TreeViewNodeMap = Record<string, NodeMetadata>;

interface TreeViewResponse {
  items: RasterLayerTreeItem[];
  nodeMap: TreeViewNodeMap;
}

export const ROOT_ITEM_ID = "root";

export const getTreeViewFromRasterLayers = (
  rasterLayers: RasterLayerMetadata[],
  attachmentUrls: AttachmentUrls,
  parentId: string = ROOT_ITEM_ID,
  depth: number = 0,
): TreeViewResponse => {
  // reverse to have the layers displayed in correct order (top to bottom)
  return rasterLayers
    .slice()
    .reverse()
    .reduce<TreeViewResponse>(
      (acc, layer) => {
        const nodeId = layer.id;
        const nodeMetadata = {
          ...layer,
          parentId,
          attachmentUrl: layer.imageAttachmentName
            ? attachmentUrls[layer.imageAttachmentName]
            : undefined,
          depth,
        };
        acc.nodeMap[nodeId] = nodeMetadata;

        const childrenView = getTreeViewFromRasterLayers(
          layer.layers || [],
          attachmentUrls,
          nodeId,
          depth + 1,
        );

        acc.items.push({
          id: nodeId,
          label: layer.name || `Layer ${nodeId}`,
          children:
            childrenView.items.length > 0 ? childrenView.items : undefined,
          metadata: nodeMetadata,
        });

        Object.assign(acc.nodeMap, childrenView.nodeMap);

        return acc;
      },
      { items: [], nodeMap: {} },
    );
};
